import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles({
  paper: {
    padding: '70px 54px',
    maxWidth: 688,
  },
  dialogContent: {
    padding: '44px 0 0',
  },
  modalButtons: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    width: 152,
    height: 57,
  },
  buttonSecondary: {
    backgroundColor: '#fff',
    color: '#00b2ae',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#008683',
    },
  },
  buttonPrimary: {
    marginLeft: 20,
  },
});
